import { useContext } from "react"

import {
  OrganizationSettingsContext,
  OrganizationSettingsContextType,
} from "~/pages/Brand/CommunicationStudio/contexts/organizationSettings/OrganizationSettingsContext"

export const useOrganizationSettings = (): OrganizationSettingsContextType => {
  const context = useContext(OrganizationSettingsContext)
  if (context === undefined) {
    throw new Error(
      "useOrganizationSettings must be used within an OrganizationSettingsProvider"
    )
  }
  return context
}
